import React, { useState, useEffect } from "react";
import Reveal from "./Reveal";
import { ArrowUpRight, X, ChevronLeft, ChevronRight } from "lucide-react";

// ── URL GROUPS ────────────────────────────────────────────────────────────────
const brandingUrls = [
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729071/ayur_bay_novotel.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729073/IMG_1765.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729073/IDLY_PODI_MOCKUP_FRONT.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729073/chettinad.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729074/IMG_1352.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729074/cochin.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729074/KFC_Branding.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729075/KANDI_PODI_BACK_MOCKUP.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729075/KANDI_PODI_FRONT_MOCKUP.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729075/Logo-FreshGrind.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729074/Klik.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728485/PEANUT_PODI_1.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729077/PeterEngland.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729078/VanHeusen.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729078/WhatsApp_Image_2020-11-19_at_6.34.24_PM.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729079/WhatsApp_Image_2020-11-19_at_7.04.40_PM_1.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729079/WhatsApp_Image_2020-11-19_at_7.04.41_PM.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729080/WhatsApp_Image_2020-11-19_at_7.15.23_PM.jpg",
];

const photoshootUrls = [
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728505/Peanut_Podi_1_2.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728486/img23.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728485/PEANUT_PODI_1.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728484/img33.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728485/022A0919.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728484/img29.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728483/img25.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728482/img27.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728479/img21.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728478/img19.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728479/img17.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728475/img7.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728475/0I5A5436_copy.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728474/img5.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728473/img15.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728472/img1.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728469/img13.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728469/img11.jpg",
];

const creativeUrls = [
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729518/WhatsApp_Image_2020-11-19_at_7.04.40_PM.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729517/WhatsApp_Image_2020-11-19_at_7.04.39_PM.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729516/WhatsApp_Image_2020-11-19_at_7.04.39_PM_1.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729515/Taproom_Poster_V2.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729516/WhatsApp_Image_2020-11-19_at_7.04.38_PM.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729516/THE_PARK_B_LORE_-_KUMAON_EXPEDITION_Standee_2x3ft.png",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729515/WhatsApp_Image_2020-11-19_at_7.04.37_PM.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729515/SEA_GREEN_DESIGN_A4_OPTION_2-01.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729512/Sailana_M.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729512/PartyAnimal.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729510/MANGOLICIOUS_main_poster.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729510/Luxury_redefined_-_Hotel.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729509/Independence4.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729508/HeatOn.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729508/GaramGaram.png",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729500/Fathers_Day_Brunch_1.2.png",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729482/16.9.18.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729482/10.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729482/AQUA_the_park_newspaper_sizefront.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729481/19.11.18.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729481/5.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729480/4.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729480/1.jpg",
];

const brandActivationUrls = [
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729071/ayur_bay_novotel.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729073/IMG_1765.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729073/IDLY_PODI_MOCKUP_FRONT.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729073/chettinad.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728505/Peanut_Podi_1_2.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728486/img23.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728485/PEANUT_PODI_1.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789728484/img33.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729518/WhatsApp_Image_2020-11-19_at_7.04.40_PM.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729517/WhatsApp_Image_2020-11-19_at_7.04.39_PM.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729516/WhatsApp_Image_2020-11-19_at_7.04.39_PM_1.jpg",
  "https://res.cloudinary.com/w9z2tolt/image/upload/v1789729515/Taproom_Poster_V2.jpg",
];

// ── DATA HELPERS ──────────────────────────────────────────────────────────────
const makeImageItems = (urls, tag, titlePrefix) =>
  urls.map((url, index) => ({
    tag,
    title: `${titlePrefix} ${String(index + 1).padStart(2, "0")}`,
    src: `${url}?w=600&q=auto&f_auto`, // ← this is the key line
    mediaType: "image",
  }));

const brandingItems = makeImageItems(brandingUrls, "Branding", "Branding");
const creativeItems = makeImageItems(creativeUrls, "Creative", "Creative");
const photoshootItems = makeImageItems(
  photoshootUrls,
  "Photoshoot",
  "Photoshoot",
);
const brandActivationItems = makeImageItems(
  brandActivationUrls,
  "Brand Activations",
  "Brand Activation",
);

const ALL_ITEMS = [
  ...brandingItems,
  ...creativeItems,
  ...photoshootItems,
  ...brandActivationItems,
];

// Split items across 4 scrolling columns
const col1 = ALL_ITEMS.filter((_, index) => index % 4 === 0);
const col2 = ALL_ITEMS.filter((_, index) => index % 4 === 1);
const col3 = ALL_ITEMS.filter((_, index) => index % 4 === 2);
const col4 = ALL_ITEMS.filter((_, index) => index % 4 === 3);

const FILTERS = [
  "All",
  "Photoshoot",
  "Branding",
  "Creative",
  "Brand Activations",
];

// ── MEDIA ────────────────────────────────────────────────────────────────────
const Media = ({ item, hoverScale = false }) => {
  const baseClass = `absolute inset-0 w-full h-full object-cover ${
    hoverScale ? "transition-all duration-500 group-hover:scale-105" : ""
  }`;

  return (
    <img src={item.src} alt={item.title} loading="lazy" className={baseClass} />
  );
};

// ── LIGHTBOX ──────────────────────────────────────────────────────────────────
const Lightbox = ({ open, index, items, onClose, onPrev, onNext }) => {
  useEffect(() => {
    if (!open) return;
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onClose, onPrev, onNext]);

  if (!open || !items.length) return null;
  const item = items[index];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/55 backdrop-blur-md"
      onClick={onClose}
    >
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors z-10"
      >
        <X size={18} />
      </button>

      {/* Prev */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        className="absolute left-4 md:left-8 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors z-10"
      >
        <ChevronLeft size={22} />
      </button>

      {/* Image */}
      <img
        src={item.src}
        alt={item.title}
        className="max-h-[88vh] max-w-[88vw] object-contain shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      />

      {/* Next */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        className="absolute right-4 md:right-8 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors z-10"
      >
        <ChevronRight size={22} />
      </button>

      {/* Counter */}
      <p className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/50 text-[11px] tracking-[0.22em] uppercase font-bold">
        {index + 1} / {items.length}
      </p>
    </div>
  );
};

// ── SCROLL CARD ───────────────────────────────────────────────────────────────
const Card = ({ item, onImageClick }) => (
  <div
    onClick={() => onImageClick(item)}
    className="group relative block w-full overflow-hidden bg-black mb-4 md:mb-6 cursor-pointer"
  >
    <div className="aspect-[4/5] relative">
      <Media item={item} />

      <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent opacity-90 group-hover:opacity-45 transition-opacity duration-500" />

      <div className="absolute top-3 right-3 w-8 h-8 bg-white text-black flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
        <ArrowUpRight size={14} />
      </div>
    </div>
  </div>
);

// ── FILTERED GRID CARD ────────────────────────────────────────────────────────
const GridCard = ({ item, onImageClick }) => (
  <div
    onClick={() => onImageClick(item)}
    className="group relative block w-full overflow-hidden bg-black rounded-sm cursor-pointer"
  >
    <div className="aspect-[4/5] relative">
      <Media item={item} hoverScale />

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent opacity-90 group-hover:opacity-60 transition-opacity duration-500" />

      <div className="absolute top-3 right-3 w-8 h-8 bg-white text-black flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
        <ArrowUpRight size={14} />
      </div>
    </div>
  </div>
);

// ── SCROLLING COLUMN ──────────────────────────────────────────────────────────
const Column = ({ items, direction = "up", duration = 32, onImageClick }) => {
  const looped = [...items, ...items];

  const animationStyle = {
    animation: `${
      direction === "up" ? "tickerUp" : "tickerDown"
    } ${duration}s linear infinite`,
    willChange: "transform",
  };

  return (
    <div className="relative overflow-hidden h-full">
      <div style={animationStyle}>
        {looped.map((item, index) => (
          <Card
            key={`${item.title}-${index}`}
            item={item}
            onImageClick={onImageClick}
          />
        ))}
      </div>
    </div>
  );
};

// ── MAIN COMPONENT ────────────────────────────────────────────────────────────
const Campaigns = () => {
  const [activeFilter, setActiveFilter] = useState("All");

  const [lightbox, setLightbox] = useState({
    open: false,
    index: 0,
    items: [],
  });

  const isFiltered = activeFilter !== "All";

  const filteredItems = isFiltered
    ? ALL_ITEMS.filter((item) => item.tag === activeFilter)
    : [];

  const openLightbox = (index, items) =>
    setLightbox({ open: true, index, items });
  const closeLightbox = () => setLightbox((prev) => ({ ...prev, open: false }));
  const prevImage = () =>
    setLightbox((prev) => ({
      ...prev,
      index: (prev.index - 1 + prev.items.length) % prev.items.length,
    }));
  const nextImage = () =>
    setLightbox((prev) => ({
      ...prev,
      index: (prev.index + 1) % prev.items.length,
    }));

  const handleMarqueeClick = (item) => {
    const index = ALL_ITEMS.findIndex((i) => i.src === item.src);
    openLightbox(index >= 0 ? index : 0, ALL_ITEMS);
  };

  const handleGridClick = (item) => {
    const index = filteredItems.findIndex((i) => i.src === item.src);
    openLightbox(index >= 0 ? index : 0, filteredItems);
  };

  return (
    <section
      id="campaigns"
      className="relative bg-white pt-20 md:pt-28 pb-0 border-t border-black/10 overflow-hidden"
    >
      <Lightbox
        open={lightbox.open}
        index={lightbox.index}
        items={lightbox.items}
        onClose={closeLightbox}
        onPrev={prevImage}
        onNext={nextImage}
      />

      <div className="px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-6 items-end mb-10 md:mb-14">
          {/* Heading */}
          <div className="col-span-12 md:col-span-7">
            <p className="flex items-center gap-2 text-[12px] tracking-[0.28em] uppercase font-bold text-[#E60000] mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-[#E60000]" />
              Our Work
            </p>

            <Reveal>
              <h2 className="font-display font-black uppercase text-[40px] sm:text-[56px] md:text-[72px] leading-[0.95] tracking-tighter text-black max-w-[14ch]">
                Work that speaks
                <br />
                before we do<span className="text-[#E60000]">.</span>
              </h2>
            </Reveal>
          </div>

          {/* Description + Filter Buttons */}
          <Reveal delay={120} className="col-span-12 md:col-span-5">
            <p className="text-base md:text-lg text-[#444] max-w-md leading-relaxed md:ml-auto">
              A selection of campaigns crafted with strategy, executed with
              precision, and built to deliver measurable impact.
            </p>

            <div className="mt-5 md:ml-auto flex flex-wrap gap-2 md:justify-end">
              {FILTERS.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setActiveFilter(filter)}
                  className={`text-[12px] tracking-[0.22em] uppercase font-bold px-5 py-2.5 border transition-all duration-200 cursor-pointer ${
                    activeFilter === filter
                      ? "bg-[#E60000] text-white border-[#E60000]"
                      : "border-black/20 text-black/70 hover:border-black hover:text-black"
                  }`}
                >
                  {filter}
                </button>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      {/* ── SCROLLING MARQUEE WALL ── */}
      {!isFiltered && (
        <div className="relative h-[620px] md:h-[780px] lg:h-[860px] px-6 md:px-12 lg:px-16">
          <div className="pointer-events-none absolute inset-x-0 top-0 h-16 md:h-24 bg-gradient-to-b from-white to-transparent z-10" />
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-16 md:h-24 bg-gradient-to-t from-white to-transparent z-10" />

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 h-full">
            <Column
              items={col1}
              direction="up"
              duration={34}
              onImageClick={handleMarqueeClick}
            />
            <Column
              items={col2}
              direction="down"
              duration={42}
              onImageClick={handleMarqueeClick}
            />
            <Column
              items={col3}
              direction="up"
              duration={38}
              onImageClick={handleMarqueeClick}
            />
            <Column
              items={col4}
              direction="down"
              duration={46}
              onImageClick={handleMarqueeClick}
            />
          </div>
        </div>
      )}

      {/* ── FILTERED STATIC GRID ── */}
      {isFiltered && (
        <div className="px-6 md:px-12 lg:px-16 pb-4">
          <div className="flex items-center justify-between mb-6">
            <p className="text-[11px] tracking-[0.22em] uppercase font-bold text-black/50">
              {filteredItems.length} result
              {filteredItems.length !== 1 ? "s" : ""} — {activeFilter}
            </p>

            <button
              onClick={() => setActiveFilter("All")}
              className="flex items-center gap-1.5 text-[10px] tracking-[0.22em] uppercase font-bold text-black/60 hover:text-[#E60000] transition-colors border border-black/20 hover:border-[#E60000] px-3 py-1.5"
            >
              <X size={10} />
              Clear filter
            </button>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
            {filteredItems.map((item, index) => (
              <GridCard
                key={`${item.title}-${index}`}
                item={item}
                onImageClick={handleGridClick}
              />
            ))}
          </div>
        </div>
      )}

      {/* ── FOOTER BAR ── */}
      <div className="px-6 md:px-12 lg:px-16 mt-12 md:mt-16 flex flex-wrap items-center gap-6 border-t border-black/10 pt-8 pb-20 md:pb-24">
        <p className="text-[12px] tracking-[0.22em] uppercase font-bold text-black/60 flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-[#E60000] animate-pulse" />
          Selected work from 40+ brands
        </p>

        <a
          href="#contact"
          className="ml-auto group inline-flex items-center gap-2 text-[12px] tracking-[0.22em] uppercase font-bold text-black border-b-2 border-black hover:text-[#E60000] hover:border-[#E60000] pb-1 transition-colors"
        >
          Request the deck
          <ArrowUpRight size={14} />
        </a>
      </div>
    </section>
  );
};

export default Campaigns;
